import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class HostService {
  host: any
  constructor() {
    // // PARA PRUEBAS
    // this.host = 'http://localhost:3000/';
    this.host = 'http://3.16.105.161:3000/';
    //console.log( window.location.hostname )
    // VALIDACION DE PRODUCCION
    // if (window.location.hostname == "190.144.77.146") {
    //   this.host = 'http://190.144.77.146:7474/';
    // } else {
    //   this.host = 'http://10.0.0.16:7474/';
    // }
    // console.log(this.host)
  }
} 